module.exports = __webpack_public_path__ + "img/shopline-one-en.218b03d1.png";